import { LoaderWithText } from "@/components/loader-with-text";
import { cn } from "@/lib/utils";

export const FullPageLoading = ({ text, className }: { text?: string; className?: string }) => {
  return (
    <div className={cn("h-dvh w-full flex items-center justify-center", className)}>
      <LoaderWithText className="gap-4" textClassName="text-base" text={text} iconClassName="size-8" />
    </div>
  );
};
